// import { stringify } from 'qs';
// import { routerRedux } from 'dva/router';

import { fetchCurUser, login, logout, saveUserHelpTime } from '@/services/api';
import { setUser } from '@/utils/authority';
import { reloadAuthorized } from '@/utils/Authorized';
import { getPageQuery } from '@/utils/utils';
import { setToken, clearToken } from '@/utils/token';
import { message } from 'antd';
import { refreshAccessToken } from '@/utils/request';
const Model = {
  namespace: 'login',
  state: {
    status: undefined,
  },
  effects: {
    *login({ payload }, { call, put }) {
      const response = yield call(login, payload);
      if (response.access_token) {
        // 保存 token 到 memoryToken
        setToken({
          access_token: response.access_token,
          token_type: response.token_type || 'Bearer',
          expires_in: response.expires_in || 0,
          token_created_at: Date.now(),
        });

        yield put({
          type: 'changeLoginStatus',
          payload: response,
        });
        const user = yield call(fetchCurUser);

        if (user && user.roles) {
          setUser(user);
        }

        if (user.permissions.includes('help_manual') && !user.help_time) {
          yield call(saveUserHelpTime);
          window.location.href = `${window.location.origin}/faq`;
        } else {
          // Login successfully
          const urlParams = new URL(window.location.href);
          const params = getPageQuery();
          let { redirect } = params;
          if (redirect) {
            const redirectUrlParams = new URL(redirect);
            if (redirectUrlParams.origin === urlParams.origin) {
              redirect = redirect.substr(urlParams.origin.length);

              if (redirect.match(/^\/.*#/)) {
                redirect = redirect.substr(redirect.indexOf('#') + 1);
              }
            } else {
              window.location.href = '/';
            }
          }
          reloadAuthorized();
          window.location.href = redirect || '/';
        }
      }
      return response;
    },
    *refresh(_, { call }) {
      // refreshAccessToken 已经处理了 429 的重试逻辑、token 设置和跨标签页通知
      const response = yield call(refreshAccessToken, { broadcast: true });
      return response;
    },
    *logout({ payload }, { call, put }) {
      // 先调用 logout 接口，需要 token 才能成功
      if (payload === 'y') {
        const res = yield call(logout);
        if (res.message !== '退出成功') {
          message.error('登出失败');
          return;
        }
      }
      clearToken();
      setUser({});
      yield put({
        type: 'changeLoginStatus',
        payload: {},
      });
      window.location.replace(`${window.location.origin}/user/login`);
      reloadAuthorized();
    },
  },
  reducers: {
    changeLoginStatus(state) {
      return { ...state, status: 'ok' };
    },
  },
};
export default Model;
